var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401 401",
    style: {
      enableBackground: "new 0 0 401 401"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.8,289.3H30.9C13.8,289.3,0,275.5,0,258.4V142.6c0-17.1,13.8-30.9,30.9-30.9h205.9c17.1,0,30.9,13.8,30.9,30.9v115.9 C267.7,275.5,253.9,289.3,236.8,289.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5,275.4L291.9,244c-5.6-1.9-9.3-7.2-9.3-13.1v-60.7c0-5.9,3.7-11.2,9.3-13.1l90.6-31.5c9-3.1,18.5,3.6,18.5,13.1v123.6 C401,271.9,391.6,278.6,382.5,275.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.b7411dc7cfddcc2f06884e97d0ee4119.svg";
export { ForwardRef as ReactComponent };